// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeRoundUnpickedListBody = {
  poolId: string;
  roundId: string;
  cursor?: string | null;
  limit?: number | null;
};

export type typeRoundUnpickedListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    roundStatus: "scheduled" | "open" | "locked" | "graded";
    items: {
      entryId: string;
      userId: string;
      displayName: string;
      photoUrl?: string | null;
    }[];
    nextCursor?: string | null;
  };
};

export type typeRoundUnpickedListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeRoundUnpickedListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeRoundUnpickedListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaRoundUnpickedListBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    roundId: { type: "string", maxLength: 3000, minLength: 1 },
    cursor: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    limit: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["poolId", "roundId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createRoundUnpickedList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaRoundUnpickedListBody);
  }

  return async function postRoundUnpickedList(
    payload: typeRoundUnpickedListBody,
  ): Promise<typeRoundUnpickedListOutput200 | typeRoundUnpickedListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postRoundUnpickedList" failed before calling the network. #7cbbc681ec98`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#7cbbc681ec98" },
        },
        data: null,
      } as typeRoundUnpickedListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/round/unpicked-list`,
      httpMethod: "POST",
      options,
    })) as typeRoundUnpickedListOutput200 | typeRoundUnpickedListOutput400;
  };
}
